// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 공용 로딩 스피너 — GrowFit 로고 회전 인디케이터 */

.loading-spinner {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  background: var(--fg-bg-card, #f5f5f7);
  border-radius: 12px;
  font-size: 14px;
  color: var(--fg-text-gray);
}

.loading-spinner__icon {
  display: block;
  flex: 0 0 auto;
  object-fit: contain;
  animation: loading-spinner-rotate 1.4s linear infinite;
}

.loading-spinner__text {
  display: inline-block;
  line-height: 1;
}

@keyframes loading-spinner-rotate {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/css/LoadingSpinner.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAEpC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,OAAO,yBAAyB,EAAE;AACpC","sourcesContent":["/* 공용 로딩 스피너 — GrowFit 로고 회전 인디케이터 */\n\n.loading-spinner {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  background: var(--fg-bg-card, #f5f5f7);\n  border-radius: 12px;\n  font-size: 14px;\n  color: var(--fg-text-gray);\n}\n\n.loading-spinner__icon {\n  display: block;\n  flex: 0 0 auto;\n  object-fit: contain;\n  animation: loading-spinner-rotate 1.4s linear infinite;\n}\n\n.loading-spinner__text {\n  display: inline-block;\n  line-height: 1;\n}\n\n@keyframes loading-spinner-rotate {\n  from { transform: rotate(0deg); }\n  to   { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
